import React from 'react';
import Heading2 from '@Components/heading_2/view';
import Heading3 from '@Components/heading_3/view';

import s from '../styles/DetailContent.module.css';

const Knowledge53 = () => {
    return (
        <div className={s.wrapper}>
            <section className={s.section}>
                <Heading2 title='入会動機書とは' fontWeight={700} />
                <p>
                    入会動機書とは、ゴルフ会員権の入会申込時にゴルフ場へ提出する、入会を希望する理由をまとめた書類です。すべてのゴルフ場で求められるわけではありませんが、格式の高いクラブほど重視される傾向があり、
                    <a href='/knowledge/17'>面接</a>
                    でも同じ内容を口頭で問われることがあります。
                    <br />
                    本記事では、入会動機書に書くべき内容と文例、書く際の注意点をご紹介します。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='入会動機書に書くべき内容' fontWeight={700} />

                <Heading3 title='そのクラブを選んだきっかけ' />
                <p>
                    知人からの紹介、コースの評判、立地の利便性など、数あるゴルフ場の中でなぜそのクラブを選んだのかを具体的に書きましょう。「有名だから」といった漠然とした理由だけでは、熱意が伝わりにくくなります。
                </p>

                <Heading3 title='ゴルフ歴・プレースタイル' />
                <p>
                    ゴルフを始めた時期、年間のラウンド回数、普段どのようなメンバーとプレーしているかなど、自身とゴルフとの関わり方を簡潔に紹介します。長くゴルフに親しんでいることが伝われば、会員としての適性を示す材料になります。
                </p>

                <Heading3 title='クラブへの共感・今後の関わり方' />
                <p>
                    クラブの歴史や理念、コースの特徴に対する共感を具体的に書き、入会後にどのように利用したいか（月例競技への参加、家族や取引先との利用など）を添えると、単なる形式的な申込書ではなく前向きな入会意思として伝わります。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='入会動機書の文例' fontWeight={700} />
                <p>
                    入会動機書の文例は、以下のとおりです。
                    <br />
                    <br />
                    <strong>
                        <u>【入会動機書の文例】</u>
                    </strong>
                    <br />
                    私は学生時代よりゴルフに親しみ、現在も月に数回のペースでラウンドしております。かねてより貴クラブの豊かな自然環境と伝統ある運営方針に魅力を感じており、この度会員権を取得する機会をいただきましたことを大変光栄に存じます。入会後は月例競技にも積極的に参加し、会員の皆様との交流を大切にしながら、末永くお世話になりたいと考えております。何卒よろしくお願い申し上げます。
                    <br />
                    <br />
                    ゴルフ場によって求められる分量や書式は異なるため、上記はあくまでも一例としてお考えください。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='書く際の注意点' fontWeight={700} />
                <p>
                    ステータスや投資目的だけを前面に出した動機は、クラブの雰囲気にそぐわないと受け取られることがあります。あくまでゴルフを楽しみ、クラブの一員として長く付き合っていきたいという姿勢を中心に据えましょう。
                    <br />
                    入会動機がうまく伝わらないことは、入会審査に落ちる理由のひとつにもなり得ます。審査全体で気を付けたいポイントは
                    <a href='/knowledge/51'>入会審査に落ちる理由と対策</a>
                    でご紹介しています。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='まとめ' fontWeight={700} />
                <p>
                    入会動機書は、クラブへの熱意と会員としての適性を伝える大切な書類です。きっかけ・ゴルフ歴・クラブへの共感の3点を具体的にまとめることで、審査担当者に前向きな印象を与えられます。
                    <br />
                    書き方に迷ったら、ゴルフ会員権業者に相談しながら準備を進めることをおすすめします。
                    <br />
                    そもそもゴルフ会員権とは何かという基礎知識は<a href='/knowledge/8'>こちら</a>をご覧ください。
                </p>
            </section>
        </div>
    );
};

export default Knowledge53;
